import React from 'react';

class MobileSidebarCard extends React.Component {
	constructor(props) {
		super(props);

		// Touch move tolerance
		this.cardTouchTolerance = 44;

		this.state = {
			mobileCardClass: ''
		};
	}

	componentDidMount() {
		// Window resize event
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
		// body touch move event
		document.body.addEventListener(
			'touchmove',
			event => {
				this.handleTouchMove(event);
			},
			false
		);
	}

	componentWillUnmount() {
		// unbind body touch move event
		document.body.removeEventListener('touchmove', this.handleTouchMove);
		window.removeEventListener('resize', this.handleResize);
	}

	handleResize = () => {
		if (window.innerWidth > 1200) {
			this.openMobileCard();
		}
	};

	handleCardTouchStart(event) {
		this.cardTouchDown = true;
		this.cardStartY = event.touches[0].clientY;
	}

	handleTouchMove(event) {
		this.cardMoveY = event.changedTouches[0].clientY;
		if (this.cardTouchDown && this.state.mobileCardClass === '') {
			let cardShiftY = this.cardMoveY - this.cardStartY;

			// overlay opacity calculation and style logic
			let overlayOpacity = Math.abs(cardShiftY) / 200;
			let overlayStyle = {};
			if (cardShiftY < 0) {
				overlayStyle = {
					transition: 'none',
					opacity: overlayOpacity > 0.7 ? 0.7 : overlayOpacity
				};
			}

			this.setState({
				mobileCardOverlayStyle: overlayStyle,
				mobileCardMoveStyle: {
					transform: `translate3d(0, calc( 50% + ${cardShiftY}px ), 0) scale3d(0.9, 0.9, 0.9)`,
					transition: 'none'
				}
			});
		}
	}

	handleCardTouchEnd(event) {
		this.cardTouchDown = false;
		this.cardEndY = event.changedTouches[0].clientY;

		// reset move style
		this.setState({
			mobileCardOverlayStyle: {},
			mobileCardMoveStyle: {}
		});

		if (this.state.mobileCardClass !== 'is-open') {
			// if card is fully open, only allow close view the footer button
			if (this.state.mobileCardClass === 'is-closed') {
				// return to default half open state
				this.setState({
					mobileCardClass: ''
				});
			} else if (this.cardEndY > this.cardStartY + this.cardTouchTolerance && !this.props.disableFooterClose) {
				// close card to footer
				this.setState({
					mobileCardClass: 'is-closed'
				});
			} else if (this.cardEndY < this.cardStartY - this.cardTouchTolerance) {
				// open card to full view
				this.setState({
					mobileCardClass: 'is-open'
				});
			}
		}
	}

	handleCardClick() {
		if (this.state.mobileCardClass !== 'is-open') {
			this.openMobileCard();
		}
		// if ( 'ontouchstart' in document.documentElement === false ) {
		// 	// non touch device
		// 	if ( this.state.mobileCardClass === 'is-closed' ) {
		// 		this.setState({
		// 			mobileCardClass: ''
		// 		});
		// 	} else if ( this.state.mobileCardClass === '' ) {
		// 		this.setState({
		// 			mobileCardClass: 'is-open'
		// 		});
		// 	}
		// }
	}

	resetMobileCard() {
		this.setState({
			mobileCardClass: ''
		});
	}

	openMobileCard = () => {
		this.setState({
			mobileCardClass: 'is-open'
		});
	};

	closeMobileCard = () => {
		this.setState({
			mobileCardClass: 'is-closed'
		});
	};

	render() {
		return (
			<div>
				<div className={`mobile-sidebar-overlay ${this.state.mobileCardClass}`} style={this.state.mobileCardOverlayStyle} />
				<div
					ref={elem => {
						this.elem = elem;
					}}
					className={`mobile-sidebar mobile-sidebar-half-card ${this.state.mobileCardClass}`}
					style={this.state.mobileCardMoveStyle}
					onTouchStart={event => this.handleCardTouchStart(event)}
					onTouchEnd={event => this.handleCardTouchEnd(event)}
					onClick={event => this.handleCardClick(event)}
				>
					{this.props.children}
					{!this.props.noCover ? <div className="mobile-sidebar-lockout-cover" /> : null}
				</div>
			</div>
		);
	}
}

export default MobileSidebarCard;
